/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _join = _interopRequireDefault(require("../../../packages/join"));
var DEFAULT_SIZE = 10;
var _default = function _default(_ref, extraProps) {
  var sortable = _ref.sortable,
    size = _ref.size,
    direction = _ref.direction,
    renderSortTool = _ref.renderSortTool;
  if (!sortable) {
    return null;
  }
  size = size || DEFAULT_SIZE;
  if (renderSortTool) {
    return renderSortTool(direction, extraProps);
  }
  var visibilityClassName = 'InovuaReactDataGrid__sort-icon';
  if (!direction) {
    visibilityClassName += ' InovuaReactDataGrid__sort-icon--hidden';
  }
  return _react.default.createElement("div", {
    className: "InovuaReactDataGrid__sort-icon-wrapper",
    key: "iconWrapper"
  }, _react.default.createElement("svg", {
    key: "sortToolAsc",
    className: (0, _join.default)(visibilityClassName, 'InovuaReactDataGrid__sort-icon--asc', direction === 1 && 'InovuaReactDataGrid__sort-icon--active'),
    width: size,
    height: size / 2,
    viewBox: "0 0 10 5"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M4.767.276L8.395 4.04c.142.147.138.382-.01.524-.069.066-.16.104-.257.104H.872c-.205 0-.37-.166-.37-.37 0-.097.036-.189.103-.258L4.233.276c.142-.147.377-.151.524-.009l.01.01z"
  })), _react.default.createElement("svg", {
    key: "sortToolDesc",
    className: (0, _join.default)(visibilityClassName, 'InovuaReactDataGrid__sort-icon--desc', direction === -1 && 'InovuaReactDataGrid__sort-icon--active'),
    width: size,
    height: size / 2,
    viewBox: "0 0 10 5"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M4.233 4.724L.605.96C.463.814.467.579.615.437.684.371.775.333.872.333h7.256c.205 0 .37.166.37.37 0 .097-.036.189-.103.258L4.767 4.724c-.142.147-.377.151-.524.009l-.01-.01z"
  })));
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/Layout/ColumnLayout/Cell/renderSortTool.js
// module id = 552
// module chunks = 0